"use client";

import { useEffect, useState } from "react";
import { useBlogContext } from "@/context/BlogContext";
import Dropdown from "@/components/Dropdown";
import apiFetch from "@/lib/fetch";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { DROPDOWN_DEFAULT_VALUE_KEYS } from "@/@core/constants/dropdown";
import { useTranslation } from "@/hooks/translationContext";

export default function BlogDropdownPart() {
  const { t } = useTranslation();
  const { setBlogFilterId } = useBlogContext();

  const [services, setServices]: any = useState([]);
  const [selectedService, setSelectedService] = useState(t("header-quicksearch-service"));
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    const getServices = async () => {
      const response = await apiFetch({ route: "blog/services" });
      setServices(response);
    };

    getServices();
  }, []);

  useEffect(() => {
    const service = searchParams.get("service");

    const getService = async () => {
      if (service) {
        const serviceData = await apiFetch({ route: `service/${service}` });
        setSelectedService(serviceData.descriptions[0]?.title);
        setBlogFilterId(serviceData.id);
      }
    };

    if (service) getService();
  }, []);

  const changeUrl = ({ service }: { service?: string }) => {
    const searchParams = new URLSearchParams();

    if (service) searchParams.append("service", service);

    router.replace(pathname + `?${searchParams.toString()}`);
  };

  return (
    <div className="border-b border-stone-50 py-4">
      <div className="container w-full flex flex-wrap sm:flex-row flex-col md:justify-center gap-2 md:items-center">
        <div className="grow shrink-0">
          <span className="text-slate-800 text-sm font-bold font-['DM Sans']">
            Hızlı Filtre
          </span>
        </div>

        <Dropdown
          parentClassName="lg:!w-[278px] w-full"
          title={selectedService}
          className="w-full"
        >
          <button
            role="button"
            className="flex items-start px-2 border-b border-stone-50 py-3 rounded cursor-pointer w-full"
            onClick={() => {
              setSelectedService(t(DROPDOWN_DEFAULT_VALUE_KEYS.SERVICE));
              setBlogFilterId(0);
              changeUrl({ service: "" });
            }}
          >
            <span className="text-sm text-slate-800 font-bold">Tümü</span>
          </button>

          {services.map((occ: { title: string; slug: string; id: number }) => {
            return (
              <button
                role="button"
                key={occ.id}
                onClick={() => {
                  setSelectedService(occ.title);
                  setBlogFilterId(occ.id);
                  changeUrl({ service: occ.slug });
                }}
                className="flex items-start px-2 border-b border-stone-50 py-3 rounded cursor-pointer w-full"
              >
                <span className="text-sm text-slate-800 font-bold">
                  {occ.title}
                </span>
              </button>
            );
          })}
        </Dropdown>
      </div>
    </div>
  );
}
